import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export const ENABLED_LANGUAGES_QUERY_KEY = ['platform-enabled-languages'] as const

/**
 * Language codes that are enabled on the platform (Language Control).
 * Only content in these languages is shown (e.g. Streaming). Used by useStreamingListings.
 * While loading, returns null so the consumer can avoid filtering to empty.
 */
export function useEnabledLanguages() {
  const { data: enabledCodes, isLoading } = useQuery({
    queryKey: ENABLED_LANGUAGES_QUERY_KEY,
    queryFn: async (): Promise<string[]> => {
      const { data, error } = await supabase
        .from('platform_enabled_languages')
        .select('language_code')
        .eq('is_enabled', true)
      if (error) throw error
      return (data ?? []).map((r) => r.language_code)
    },
    staleTime: 60_000,
  })
  return {
    enabledLanguages: isLoading ? null : (enabledCodes ?? []),
    isLoading,
  }
}
